import { useState, type FormEvent } from "react";
import { Button, Input } from "@bastion/ui";
import { useAuthStore } from "@/shared/stores/authStore";
import styles from "./LoginPage.module.css";

const DEV_AUTH_ENABLED = import.meta.env.VITE_DEV_AUTH === "true";

export function LoginPage() {
  const { signInWithGoogle, signInWithPassword, isLoading, error } = useAuthStore();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handlePasswordLogin = async (e: FormEvent) => {
    e.preventDefault();
    await signInWithPassword(email, password);
  };

  return (
    <div className={styles.container} data-testid="page-login">
      <div className={styles.card}>
        <h1 className={styles.title}>
          Parametric <span className={styles.product}>Bastion</span>
        </h1>
        <p className={styles.subtitle}>
          Data collection and ML training orchestration
        </p>

        <Button onClick={signInWithGoogle} disabled={isLoading} className="w-full">
          {isLoading ? "Signing in..." : "Sign in with Google"}
        </Button>

        {DEV_AUTH_ENABLED && (
          <>
            <div className={styles.divider}>
              <div className={styles.rule} />
              <span className={styles.dividerLabel}>or dev sign-in</span>
              <div className={styles.rule} />
            </div>
            <form onSubmit={handlePasswordLogin} className={styles.form}>
              <Input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <Input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <Button type="submit" disabled={isLoading} className="w-full" variant="outline">
                {isLoading ? "Signing in..." : "Dev sign in"}
              </Button>
            </form>
          </>
        )}

        {error && <p className={styles.error}>{error}</p>}
      </div>
    </div>
  );
}
